import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { handleFormError } from '@/utils/helpers.js'
import { toast } from 'sonner'

export default function useCreateVault({ setError }) {
  const queryClient = useQueryClient()

  const action = async ({
    name = null,
    description,
    initial_balance = null,
    balance_as_of = null,
    vault_group: { id, name: groupName, description: groupDescription },
  }) => {
    const response = await httpClient.post('team/vault', {
      name,
      description,
      initial_balance,
      balance_as_of,
      vault_group: {
        id,
        name: id ? null : groupName,
        description: id ? null : groupDescription,
      },
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    // onError: (e) => {
    //     toast.error(e?.response?.data?.message ?? 'An error occurred.')
    // },
    onSuccess: (e) => {
      queryClient.invalidateQueries({
        queryKey: ['vaults'],
      })

      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
      // The first Vault can make the one-time email preferences prompt due.
      queryClient.invalidateQueries({
        queryKey: ['current-user'],
      })
      toast.success(e?.response?.data?.message ?? 'Vault successfully added.')
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        showToast: true,
      }),
  })

  return {
    createVault: mutation.mutateAsync,
  }
}
